import React from 'react';
import { chakra, shouldForwardProp, Box, BoxProps } from '@chakra-ui/react';
import { motion, isValidMotionProp, useInView } from 'framer-motion';

type Props = {
  children: React.ReactNode;
} & BoxProps;

const ChakraBox = chakra(motion.div, {
  /**
   * Allow motion props and non-Chakra props to be forwarded.
   */
  shouldForwardProp: prop => isValidMotionProp(prop) || shouldForwardProp(prop)
});

export const FadeDown: React.FC<Props> = ({ children, ...props }) => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <Box ref={ref} {...props}>
      <ChakraBox
      transition='all 0.9s ease'
      opacity={isInView ? 1 : 0}
      transform={isInView ? 'translateY(0)' : 'translateY(-50px)'}
      >
        {children}
      </ChakraBox>
    </Box>
  );
};
